import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as routes from '../constants/routes';
import NotFound from '../components/NotFound';
import SearchPage from './SearchPage';
import ClientPage from './ClientPage';
import SupplierPage from './SupplierPage';
import ActualEnterprisesPage from './ActualEnterprisesPage';
import SalesOrdersPage from './SalesOrdersPage';
import AddClientPage from './AddClientPage';
import ElevatorPage from './ElevatorPage';
import LoginForm from './LoginForm';
import SettingsPage from './SettingsPage';
import SupplierDetailPage from './SupplierDetailPage';
import ClientDetailPage from './ClientDetailPage';
import ElevatorDetailPage from './ElevatorDetailPage';
import UserDetailPage from './UserDetailPage';
import ManageUsersTasks from './ManageUsersTasks';
import { loadInitData } from '../actions/webInterface';
import PrivateRoute from '../components/PrivateRoute';
import Home from '../components/Home';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn: !!props.authToken
		}
	}

	componentDidMount() {
		if (this.props.authToken) {
			this.props.loadInitData();
		}
	}

	componentWillReceiveProps(nextProps) {
		const nextPropsAuthToken = nextProps.authToken;
		if (nextPropsAuthToken !== this.props.authToken) {
			this.setState({
				loggedIn: !!nextPropsAuthToken
			});
		}
	}

	render() {
		const { modules, initDataLoading } = this.props;
		const { loggedIn } = this.state;
		const isModulesAvalaible = modules && !initDataLoading;
		const routeKeys = Object.keys(routes);
		const firstNavigationPath = isModulesAvalaible ? routes[routeKeys.find(link => modules[link.toLowerCase()])] : null;
		const routeProps = keyString => ({
			isLoggedin: loggedIn,
			isModulesLoaded: isModulesAvalaible,
			isAvalaible: modules ? modules[keyString] : false,
			firstNavigationPath
		});

		return (
			<Router>
				<Route render={props => {
					if (!loggedIn) {
						return <LoginForm {...props} redirectPath="/" />
					} else {
						return <Switch>
							<Route path="/" exact children={
								({ history }) => <Home history={history} firstNavigationPath={firstNavigationPath} />
							} />
							<Route path="/login" children={() => <LoginForm redirectPath={firstNavigationPath || '/'} />} />
							<PrivateRoute path={routes.SEARCH} component={SearchPage} data={routeProps('search')} />
							<PrivateRoute path={routes.ACTUAL_ENTERPRISES} component={ActualEnterprisesPage} data={routeProps('actual_enterprises')} />
							<PrivateRoute path={routes.ACTUAL_OFFERS} component={SalesOrdersPage} data={routeProps('actual_offers')} />
							<PrivateRoute path={routes.SUPPLIER} component={SupplierPage} data={routeProps('supplier')} />
							<PrivateRoute path={routes.SUPPLIER_DETAIL} component={SupplierDetailPage} data={routeProps('supplier')} />
							<PrivateRoute path={routes.CLIENTS_DETAIL} component={ClientDetailPage} data={routeProps('client')} />
							<PrivateRoute path={routes.CLIENT} component={ClientPage} data={routeProps('client')} />
							<PrivateRoute path={routes.ELEVATOR} component={ElevatorPage} data={routeProps('elevator')} />
							<PrivateRoute path={routes.ELEVATOR_DETAIL} component={ElevatorDetailPage} data={routeProps('elevator')} />
							<PrivateRoute path={routes.ADD} component={AddClientPage} data={routeProps('supplier')} />
							<PrivateRoute path={routes.SETTINGS} component={SettingsPage} data={routeProps('settings')} />
							<PrivateRoute path={routes.MANAGE_TASKS} component={ManageUsersTasks} data={routeProps('settings')} />
							<PrivateRoute path={routes.USER_DETAIL} component={UserDetailPage} data={routeProps('settings')} />
							<Route component={NotFound} />
						</Switch>
					}
				}} />
			</Router>
		);
	}
}

App.propTypes = {
	authToken: PropTypes.string,
	loadInitData: PropTypes.func,
	modules: PropTypes.object,
	initDataLoading: PropTypes.bool
}

const mapStateToProps = ({ webInterface: { authToken, initData, loading } }) => ({
	authToken,
	modules: initData ? initData.available_modules : null,
	initDataLoading: loading
});

const mapDispatchToProps = dispatch => ({
	loadInitData: () => dispatch(loadInitData())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./containers/App.js